import { Cart, CartModal } from "../context/CartContext/CartContext.api.types";
import request from "./request";

type CreateCartVariationDto = {
  customization?: string;
  variationId: string;
  quantity: number;
};

type CreateCartDto = {
  items: CreateCartVariationDto[];
};

export const CartService = {
  store: (createCartDto: CreateCartDto) => {
    return localStorage.setItem(
      "localCart",
      JSON.stringify(createCartDto.items)
    );
  },
  get: () => {
    const val = localStorage.getItem("localCart");
    if (val) {
      return JSON.parse(String(val));
    } else {
      return null;
    }
  },
  getModalData: (createCartDto: CreateCartDto): Promise<CartModal> => {
    return request({
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/modal-cart`,
      data: createCartDto,
    });
  },

  create: (createCartDto: CreateCartDto): Promise<Cart> => {
    return request({
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/cart`,
      data: createCartDto,
    });
  },

  createOrder: (cartItems: CreateCartVariationDto[]): Promise<any> => {
    return request({
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/cart/create-order`,
      data: {
        items: cartItems,
      },
    });
  },

  checkout: (checkoutCartDto: FormData) => {
    return request({
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/cart/xo`,
      data: checkoutCartDto,
    });
  },
};
